import React, { useState } from "react";
import {Button, Modal, Form, Input, Col, Row} from "antd";
import { contactUsService } from '../../services/contactUs.service';
import imgContactUS from "../../assets/imgs/contact_us.jpg";
import "./modalContact.scss";
import {MessageSuccess} from "../messageSuccess/messageSuccess";
import {useLockBodyScroll} from "../../hooks/useLockBodyScroll";
import {FaEnvelope, FaPhone, FaWhatsapp} from "react-icons/fa";



export const ModalContact = (props) => {
    const { TextArea } = Input;
    const [form] = Form.useForm();
    const [submittable, setSubmittable] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [contact, setContact] = useState({
        subject: "",
        email: "",
        textMessage: "",
        companyId: process.env.REACT_APP_COMPANY,
    });
    const [isFormSuccess, setIsFormSuccess] = useState(false);
    useLockBodyScroll(openModal);
    const [formCompleted, setFormCompleted] = useState(false);

    const submitMyForm = async (contact) => {
        try {
            setSubmittable(true);

            const result = await contactUsService.sendContactMessage(contact);

            if (result.responseCode === "00") {
                setIsFormSuccess(true);
                setFormCompleted(true);
            }
        } catch (error) {
            console.error("Error al enviar mensaje de contacto:", error);
            setIsFormSuccess(true);
            setFormCompleted(false);
            handleClearForm();
        } finally {
            setSubmittable(false);
        }
    };

    const handleClearForm = () => {
        form.resetFields();
        setContact({
            subject: "",
            email: "",
            textMessage: "",
            companyId: process.env.REACT_APP_COMPANY,
        });
        setSubmittable(false);
    }

    const showContact = () => {
        setOpenModal(!openModal);
    };

    const handleHideModal = () => {
        setOpenModal(false);
        setFormCompleted(false);
        setIsFormSuccess(false);
        handleClearForm();
    }

    const handleInputChange = (e) => setContact({...contact, [e.target.name]: e.target.value})

    return (
        <>
            <Button onClick={showContact} htmlType={"button"}>Contacto</Button>
            <Modal
                rootClassName="modal-contact"
                open={openModal}
                centered
                width={820}
                footer={false}
                closable={false}
                onCancel={handleHideModal}
            >
                <div className="modal-contact__poster" style={{
                    backgroundImage: `url(${imgContactUS})`,
                }}></div>
                <div className="modal-contact__form">
                    <div className="modal-contact__form-container">
                        <h3>¡Contáctanos!</h3>
                        <div className="contact-numbers">
                            <a href="mailto:contacto@pridemx.com" className="contact-link">
                                <FaEnvelope /> <span>contacto@pridemx.com</span>
                            </a>
                            <a
                                href="https://wa.me/5650334644"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="contact-link"
                            >
                                <FaWhatsapp /> <span>56 5033 4644</span>
                            </a>
                        </div>
                        {
                            (isFormSuccess) ?
                                <MessageSuccess
                                    title={(formCompleted) ? "Correo enviado exitosamente" : " Hubo un error al intentar enviar el correo"}
                                    isSuccess={formCompleted}
                                    handleButtonClick={handleHideModal}
                                />
                                :
                                <Form
                                    form={form}
                                    layout="vertical"
                                    autoComplete="off"
                                    className="form-light"
                                    onFinish={submitMyForm}
                                >
                                    <Row gutter={[0,8]}>
                                        <Col xs={24}>
                                            <Form.Item
                                                label={"Asunto"}
                                                name={"subject"}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "*Campo requerido, máximo 100 caracteres.",
                                                        max: 100,
                                                    },
                                                ]}
                                            >
                                                <Input name="subject" onChange={handleInputChange} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24}>
                                            <Form.Item label="Correo electrónico" name={"email"} rules=
                                                {[
                                                    {
                                                        type: "email",
                                                        required: true,
                                                        message: "*Ingresa un correo electrónico valido",
                                                    },
                                                ]}
                                            >
                                                <Input name="email" onChange={handleInputChange} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24}>
                                            <Form.Item label="Mensaje" name={"textMessage"} rules=
                                                {[
                                                    {
                                                        required: true,
                                                        message: "*Ingresa un mensaje de al menos 10 caracteres.",
                                                        min: 10,
                                                    },
                                                ]}
                                            >
                                                <TextArea rows={2} name= "textMessage" onChange={handleInputChange} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24}>
                                            <div className={"form-light__footer"}>
                                                <Button
                                                    type="default"
                                                    htmlType="button"
                                                    block={true}
                                                    onClick={handleHideModal}
                                                >
                                                    Cerrar
                                                </Button>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    block={true}
                                                    loading={submittable}
                                                >
                                                    Enviar mensaje
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                        }
                    </div>
                </div>
            </Modal>
        </>
    );
};
